import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getCSRFToken } from '../common/Csrf'

import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import CircularProgress from "@material-ui/core/CircularProgress";
import { withStyles } from "@material-ui/core";

import AppContainer from "../common/AppContainer";

import * as authActions from "./actions";
import { Permission } from "../page/models";
import * as navActions from "../common/actions";

const styles = (theme) => ({
    marginTopMain: {
        marginTop: 24,
    },
    marginBottomButton: {
        marginBottom: 24,
    },
    marginBottomMain: {
        [theme.breakpoints.up("md")]: {
            marginBottom: 72,
        },
        [theme.breakpoints.down("sm")]: {
            display: "none",
        },
    },
});
const getdashboardPermissions = Permission.selectAll();

class Entra extends Component {
    state = {
        loading: false
    }
    logOut = () => {
        const { authState, history } = this.props;
        this.props.authLogout(authState, history);
    };

    continueDashboard = () => {
        if (this.props.authState.user.default_dashboard) this.props.history.push("/dashboard/" + this.props.authState.user.default_dashboard);
        else this.props.history.push("/dashboard");
    };

    handleLogin = () => {
        this.setState({loading: true});
        // Create and submit a hidden form to POST to the backend
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = '/_allauth/browser/v1/auth/provider/redirect';
        form.style.display = 'none';

        // Add required fields
        const provider = document.createElement('input');
        provider.name = 'provider';
        provider.value = 'microsoft';
        form.appendChild(provider);

        const process = document.createElement('input');
        process.name = 'process';
        process.value = 'login';
        form.appendChild(process);

        const callbackUrl = document.createElement('input');
        callbackUrl.name = 'callback_url';
        callbackUrl.value = window.location.origin + '/accounts/microsoft/login/callback/';
        form.appendChild(callbackUrl);

        const csrf = document.createElement('input');
        csrf.name = 'csrfmiddlewaretoken';
        csrf.value = getCSRFToken();
        form.appendChild(csrf);

        const tenant = document.createElement('input');
        tenant.name = 'tenant';
        tenant.value = "ebfbdb56-005a-4e63-b356-08905b9417a3"; // This will be a dropdown or separate pages for each tenant
        form.appendChild(tenant);

        document.body.appendChild(form);
        form.submit();
    };

    render() {
        const { classes, authState } = this.props;
        const { loading } = this.state;

        return (
            <AppContainer>
                <Grid container spacing={5} justifyContent="center">
                    <Grid item xs={11} md={8} lg={6} xl={4}>
                        <Typography variant="h6" gutterBottom className={classes.marginTopMain}>
                            <b>Welcome to the MS4Front Data Management Platform</b>
                        </Typography>
                        <Typography variant="body1" className={classes.marginBottomMain}>
                        A Software as a Service (SaaS) platform to tackle organizations most challenging data management needs. Our platform provides configurable data entry forms, GIS integration and reporting tools.  
                        Our roots stem from helping City and Counties with their MS4 permit tracking but recently our system has been extending to assist numerous other organizations. Those include grant, conservation and regulatory permit program management.
                        </Typography>
                        {authState?.user ? (
                            <div>
                                <Typography variant="h6" gutterBottom={true}>
                                    Welcome, {authState.user.name}
                                </Typography>
                                <Button onClick={this.continueDashboard} variant="contained" color="primary" fullWidth className={classes.marginBottomButton}>
                                    Continue to Dashboard
                                </Button>
                                <Button onClick={this.logOut} fullWidth>
                                    Logout
                                </Button>
                            </div>
                        ) : (
                            <div>
                                {!loading ? (
                                    <Button onClick={this.handleLogin} variant="contained" color="primary" fullWidth className={classes.marginBottomButton}>
                                        Single Sign-On
                                    </Button>
                                ) : (
                                    <Typography variant="h6" style={{textAlign:"center"}}>
                                        Authenticating... Please wait
                                        <CircularProgress
                                            size={72}
                                            style={{ display: "table", marginLeft: "auto", marginRight: "auto", zIndex:90000 }}
                                        /> 
                                    </Typography>
                                )}
                            </div>
                        )}
                    </Grid>
                </Grid>
            </AppContainer>
        )
    }
}
Entra.displayName = "Entra";
Entra = connect((state) => ({ authState: state.auth, dashboardPermissions: getdashboardPermissions(state) }), {
    ...authActions,
    ...navActions,
})(Entra);

export default withStyles(styles)(withRouter(Entra));
